// extracted by mini-css-extract-plugin
module.exports = {"image":"section-levitation-module--image--VFJGL","cercle":"section-levitation-module--cercle--2DCy4"};